import { Link } from "react-router-dom";

/**
 * Official Foodie Finder logo mark.
 *
 * The PNG already contains the full circular "FOODIE-FINDER" wordmark, so the
 * component renders only the image — no separate text wordmark next to it.
 *
 * Sizes (square):
 *   xs → 28px (mobile bottom nav, footer)
 *   sm → 36px (header default)
 *   md → 44px (footer / cards)
 *   lg → 64px (auth pages)
 *   xl → 96px (hero / splash)
 */
const SIZE_PX = { xs: 28, sm: 36, md: 44, lg: 64, xl: 96 };

export function BrandMark({
  size = "sm",
  asLink = true,
  to = "/",
  className = "",
  testid = "brand-link",
  withTagline = false,
}) {
  const px = SIZE_PX[size] || SIZE_PX.sm;

  const mark = (
    <img
      src="/brand/foodie-finder-logo.png"
      alt="Foodie Finder"
      width={px}
      height={px}
      style={{ width: px, height: px }}
      className="block select-none object-contain"
      draggable={false}
    />
  );

  const content = withTagline ? (
    <div className="inline-flex items-center gap-3">
      {mark}
      <span className="inline-flex flex-col leading-tight">
        <span
          className="font-bold tracking-tight text-slate-900"
          style={{ fontSize: "19px", lineHeight: "1.1" }}
        >
          FoodieFinder
        </span>
        <span
          className="font-semibold uppercase"
          style={{
            fontSize: "11.5px",
            letterSpacing: "0.14em",
            color: "#E8692A",
            marginTop: "2px",
          }}
        >
          Find. Order. Serve.
        </span>
      </span>
    </div>
  ) : (
    mark
  );

  if (!asLink) {
    return (
      <span className={`inline-flex items-center ${className}`} data-testid={testid}>
        {content}
      </span>
    );
  }

  return (
    <Link
      to={to}
      className={`inline-flex items-center transition hover:opacity-90 ${className}`}
      data-testid={testid}
      aria-label="Foodie Finder home"
    >
      {content}
    </Link>
  );
}

export default BrandMark;
